// src/pages/Menu/Dashboard/MainDashboard/Dashboard.jsx
import './index.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';
import MenuLateral from '../../../components/MenuLateral';

import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
    BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer,
} from 'recharts';

import api from '../../../api';

export default function Dashboard() {
    const navigate = useNavigate();

    const [categorias, setCategorias] = useState(0);
    const [produtos, setProdutos] = useState(0);
    const [produtosCritico, setProdutosCritico] = useState([]);
    const [clientes, setClientes] = useState(0);
    const [fornecedores, setFornecedores] = useState(0);
    const [pedidosPendentes, setPedidosPendentes] = useState(0);
    const [itensEstoque, setItensEstoque] = useState(0);
    const [favoritos, setFavoritos] = useState(0);

    const formatarDataHora = (data) => {
        if (!data) return 'N/A';
        const date = new Date(data);
        return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    };


    const [data, setData] = useState({
        vendas: [],
        distribuicao: [],
        novos: [],
        ultimos: [],
        critico: [],
        buscasTop: [],
        buscasSemResultado: []
    });


    const [loading, setLoading] = useState(true);
    const COLORS = ['#131C46', '#FFC300', '#4AC204', '#FC0000', '#8884D8', '#82CA9D'];

    useEffect(() => {
        async function fetchDashboard() {
            try {
                const [c, v, d, n, u, e, s] = await Promise.all([
                    api.get('/dashboard/contadores'),
                    api.get('/dashboard/vendas-mensais'),
                    api.get('/dashboard/distribuicao-categorias'),
                    api.get('/dashboard/novos-usuarios'),
                    api.get('/dashboard/ultimos-pedidos', { params: { limit: 5 } }),
                    api.get('/dashboard/estoque-critico'),
                    api.get('/dashboard/relatorio-buscas', { params: { limit: 5, days: 30 } })
                ]);

                if (c.data.success) {
                    const cont = c.data.contadores;
                    setCategorias(cont.categorias);
                    setProdutos(cont.produtos);
                    setClientes(cont.clientes);
                    setFornecedores(cont.fornecedores);
                    setPedidosPendentes(cont.pedidosPendentes);
                    setItensEstoque(cont.itensEstoque);
                    setFavoritos(cont.favoritos);
                }

                if (v.data.success) setData(prev => ({ ...prev, vendas: v.data.vendas }));
                if (d.data.success) setData(prev => ({ ...prev, distribuicao: d.data.distribuicao }));
                if (n.data.success) setData(prev => ({ ...prev, novos: n.data.novos }));
                if (u.data.success) setData(prev => ({ ...prev, ultimos: u.data.pedidos }));
                if (e.data.success) setProdutosCritico(e.data.critico);
                if (s.data.success) {
                    setData(prev => ({
                        ...prev,
                        buscasTop: s.data.topBuscas || [],
                        buscasSemResultado: s.data.semResultado || []
                    }));
                }

            } catch (err) {
                console.error('Erro ao carregar dashboard:', err);
            } finally {
                setLoading(false);
            }
        }
        fetchDashboard();
    }, []);

    const handleViewPedido = (id) => {
        console.log(`Visualizar produto com ID: ${id}`);
        navigate('/menu/pedidos/visualizarpedido', { state: { id } });
    };

    const handleViewProduto = (id_produto) => {
        console.log(`Visualizar produto com ID: ${id_produto}`);
        navigate('/menu/produtos_e_estoque/visualizarproduto', { state: { id_produto } });
    };

    return (
        <section className="container-principal-dashboard">
            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <div className="dashboard-content">
                    <div className='dashboard-title'>
                        <h1 className="dashboard-title">
                            Dashboard
                        </h1>
                    </div>
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando dashboard...</h2>
                        </div>
                    ) : (
                        <>
                        <section className="cards-grid">
                            <div className="card categorias" onClick={() => navigate('/menu/categorias')}>
                                <h3>Categorias</h3>
                                <p className="value">{categorias}</p>
                            </div>
                            <div className="card produtos" onClick={() => navigate('/menu/produtos_e_estoque')}>
                                <h3>Produtos</h3>
                                <p className="value">{produtos}</p>
                            </div>
                            <div className="card clientes" onClick={() => navigate('/menu/clientes')}>
                                <h3>Clientes</h3>
                                <p className="value">{clientes}</p>
                            </div>
                            <div className="card fornecedores" onClick={() => navigate('/menu/fornecedores')}>
                                <h3>Fornecedores</h3>
                                <p className="value">{fornecedores}</p>
                            </div>
                            <div className="card pedidos" onClick={() => navigate('/menu/pedidos')}>
                                <h3>Pedidos Pendentes</h3>
                                <p className="value">{pedidosPendentes}</p>
                            </div>
                            <div className="card estoque">
                                <h3>Itens em Estoque</h3>
                                <p className="value">{itensEstoque}</p>
                            </div>
                            <div className="card favoritos">
                                <h3>Favoritos</h3>
                                <p className="value">{favoritos}</p>
                            </div>
                        </section>
                        <div className='conteudo-dashboard-geral'>
                            <div className='conteudo-esquerda'>
                                <section className="charts-grid">
                                    <div className="chart-card">
                                        <h3>Vendas - Últimos 6 meses</h3>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <LineChart data={data.vendas}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="mes" />
                                                <YAxis />
                                                <Tooltip />
                                                <Line type="monotone" dataKey="total" stroke={COLORS[0]} />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>

                                    <div className="chart-card">
                                        <h3>Distribuição por Categoria</h3>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <PieChart>
                                                <Pie data={data.distribuicao} dataKey="qtd" nameKey="nome" outerRadius={80} label>
                                                    {data.distribuicao.map((e, i) => (
                                                        <Cell key={i} fill={COLORS[i % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>

                                    <div className="chart-card">
                                        <h3>Novos Usuários/Mês</h3>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <BarChart data={data.novos}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="mes" />
                                                <YAxis />
                                                <Tooltip />
                                                <Bar dataKey="qtd" fill={COLORS[1]} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </section>
                            </div>
                            <div className="ultimos-pedidos">
                                <h3>Últimos Pedidos</h3>
                                {data.ultimos.length === 0 ? (
                                    <div className="container-interno-produtos">
                                        <p className='nenhum-produto'>Nenhum pedido encontrado =(</p>
                                    </div>
                                ) : (
                                    <table className="tabela-produtos">
                                        <thead className="conteudo">
                                            <tr>
                                                <th>ID</th>
                                                <th>Cliente</th>
                                                <th>Status</th>
                                                <th>Total</th>
                                                <th>Data</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.ultimos.map((p) => (
                                                <tr className="conteudo" key={p.id}>
                                                    <td className="primeiro">{p.id}</td>
                                                    <td>{p.cliente_nome}</td>
                                                    <td>{p.status}</td>
                                                    <td>R$ {p.total}</td>
                                                    <td>{formatarDataHora(p.criado_em)}</td>
                                                    <td className="final">
                                                        <div className="bnts-produtos">
                                                            <button className='bnt-visualizar' onClick={() => handleViewPedido(p.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z" stroke-width="0.3" /></svg></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                        <div className="conteudo-direita">
                            <div className="critical-stock">
                                <h3>Estoque Crítico</h3>

                                {(produtosCritico || []).length === 0 ? (
                                    <div className="container-interno-produtos">
                                        <p className='nenhum-produto'>Nenhum produto crítico encontrado =(</p>
                                    </div>
                                ) : (
                                    <table className="tabela-produtos">
                                        <thead className="conteudo">
                                            <tr>
                                                <th>Produto</th>
                                                <th>Estoque</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(produtosCritico || []).map(p => (
                                                <tr className="conteudo" key={p.id_variacao}>
                                                    <td className="primeiro">{p.nome_produto}</td>
                                                    <td>{p.estoque}</td>
                                                    <td className="final">
                                                        <div className="bnts-produtos">
                                                            <button className='bnt-visualizar' onClick={() => handleViewProduto(p.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z" stroke-width="0.3" /></svg></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            <div className="critical-stock">
                                <h3>Buscas Mais Frequentes</h3>
                                {(data.buscasTop || []).length === 0 ? (
                                    <div className="container-interno-produtos">
                                        <p className='nenhum-produto'>Nenhuma busca frequente encontrada =(</p>
                                    </div>
                                ) : (
                                    <table className="tabela-produtos">
                                        <thead className="conteudo">
                                            <tr>
                                                <th>Busca</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(data.buscasTop || []).map((b, index) => (
                                                <tr className="conteudo" key={`${b.search_query}-${index}`}>
                                                    <td className="primeiro">{b.search_query}</td>
                                                    <td className="final">{b.total_buscas}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            <div className="critical-stock">
                                <h3>Buscas Sem Resultado</h3>
                                {(data.buscasSemResultado || []).length === 0 ? (
                                    <div className="container-interno-produtos">
                                        <p className='nenhum-produto'>Nenhuma busca sem resultado =(</p>
                                    </div>
                                ) : (
                                    <table className="tabela-produtos">
                                        <thead className="conteudo">
                                            <tr>
                                                <th>Busca</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(data.buscasSemResultado || []).map((b, index) => (
                                                <tr className="conteudo" key={`${b.search_query}-zero-${index}`}>
                                                    <td className="primeiro">{b.search_query}</td>
                                                    <td className="final">{b.total_buscas}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                        </>
                    )}
                </div>
            </main>
            <Rodape />
        </section>
    );
}